import config from "config/config";
import { convertPayloadToQueryString } from "js/utilities";

export async function releaseing_getPaymentUID(payload) {
  const qs = convertPayloadToQueryString(payload);

  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/paymentuid?${qs}`,
    {
      headers: {
        ClientSecret: config.PORTAL_CLIENT_SECRET,
      },
    }
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
